import * as types from '@types'
import * as services from '@services/formation'
import { getCustomFields } from '@services/personalInfo'
import { resolveCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'

export default {
  state: {
    formation: [
      { id: new Date().getUTCMilliseconds(), files: [] }
    ],
    options: {
      formation: {
        educationTypes: []
      }
    },
    customFields: {}
  },

  getters: {},

  mutations: {
    [types.EMPLOYEE_EDUCATION]: (state, formations) => {
      state.formation = [ ...formations ]
    },

    [types.EMPLOYEE_ADD_EDUCATION]: (state) => {
      state.formation = [
        ...state.formation,
        { id: new Date().getUTCMilliseconds(), files: [] },
      ]
    },

    [types.EMPLOYEE_SET_EDUCATION]: (state, { data, id, previousId }) => {
      const index = state.formation.findIndex(formation => formation.id === (previousId || id))

      if (index >= 0)
        state.formation.splice(index, 1, { files: [], ...data })
      else
        state.formation.push({ ...data })
    },

    [types.EMPLOYEE_DELETE_EDUCATION]: (state, formation) => {
      const formations = state.formation?.filter(({ id }) => id !== formation.id) || []

      state.formation = [ ...formations ]
    },

    [types.EMPLOYEE_SET_EDUCATION_FILES]: (state, { id, files }) => {
      const formation = state.formation.find(formation => formation.id === id)

      if (!formation)
        return

      formation.files = [ ...files ]
    },

    [types.EMPLOYEE_EDUCATION_OPTIONS]: (state, options) => {
      state.options = { ...options }
    },

    [types.EMPLOYEE_EDUCATION_CUSTOM_FIELDS]: (state, data) => {
      state.customFields = { ...data }

      state.formation = resolveCustomFieldValues(
        state.formation,
        state.customFields?.educations
      )
    }
  },

  actions: {
    [types.EMPLOYEE_EDUCATION_OPTIONS]: async ({ state, commit }) => {
      if (state.options.formation.educationTypes.length) return [ false, state.options ]

      const [ err, options ] = await services.getOptions()

      if (!err) commit(types.EMPLOYEE_EDUCATION_OPTIONS, options)

      return [ err, options ]
    },

    [types.EMPLOYEE_EDUCATION_CUSTOM_FIELDS]: async ({ commit, getters }) => {
      const [ err, data ] = await getCustomFields(getters)

      if (!err) commit(types.EMPLOYEE_EDUCATION_CUSTOM_FIELDS, data)

      return [ err, data ]
    },

    [types.EMPLOYEE_EDUCATION]: async ({ getters, commit, dispatch }) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId }
      const [ err, data ] = await services.getFormations(params)

      if (!err && data?.length) commit(types.EMPLOYEE_EDUCATION, data)

      await dispatch(types.EMPLOYEE_EDUCATION_CUSTOM_FIELDS)

      return [ err, data ]
    },

    [types.EMPLOYEE_SET_EDUCATION]: async ({ state, commit, getters }, data) => {
      const { schema } = state.customFields.educations || {}
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId, schema }
      const isCreating = typeof data?.id !== 'string'

      if (isCreating) {
        const [ err, formation ] = await services.createFormation(data, params)

        if (!err) commit(types.EMPLOYEE_SET_EDUCATION, { data: formation, previousId: data?.id })

        return [ err, formation ]
      }

      const [ err ] = await services.updateFormation(data, params)

      return [ err, data ]
    },

    [types.EMPLOYEE_SET_EDUCATIONS]: async ({ state, dispatch }, formations) => {
      if (!formations.length) return [ false, state.formation ]

      const submitted = []
      const errors = []

      const results = await Promise.allSettled((formations || [])
        .map(data => dispatch(types.EMPLOYEE_SET_EDUCATION, data))
      )

      results.forEach(({ value: [ err, formation ] = [] }) => err
        ? errors.push(err)
        : submitted.push(formation)
      )

      if (!errors.length) await dispatch(types.EMPLOYEE_EDUCATION)

      return [ errors, submitted ]
    },

    [types.EMPLOYEE_DELETE_EDUCATION]: async ({ state, getters, commit }, formation) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId }
      const [ err ] = await services.deleteFormation(formation, params)

      if (!err) commit(types.EMPLOYEE_DELETE_EDUCATION, formation)

      const hasNoFormations = !state.formation?.length

      if (hasNoFormations) commit(types.EMPLOYEE_ADD_EDUCATION)

      return [ err, null ]
    },

    [types.EMPLOYEE_EDUCATION_UPLOAD_FILES]: async ({ getters }, { id, files }) => {
      const employeeId = getters.getEmployeeUuid
      const params = { id, files, employeeId }
      const [ err, data ] = await services.uploadFormationFiles(params)

      if (err) return [ err, [] ]

      return [ err, data ]
    },
  }
}
